import Langman from "../../assets/h-langman.png"
import Langman2 from "../../assets/h-langman-2.png"
import Langman3 from "../../assets/h-langman-3.png"
import Langman4 from "../../assets/h-langman-4.png"
import Langman5 from "../../assets/h-langman-5.png"
import Langman6 from "../../assets/h-langman-6.png"
import Hospital from "../../assets/hospital-otomation.png"
import Hospital2 from "../../assets/hospital-otomation-2.png"
import Hospital3 from "../../assets/hospital-otomation-3.png"
import Hospital4 from "../../assets/hospital-otomation-4.png"
import Hospital5 from "../../assets/hospital-otomation-5.png"
import Hospital6 from "../../assets/hospital-otomation-6.png"
import Hospital7 from "../../assets/hospital-otomation-7.png"
import Hospital8 from "../../assets/hospital-otomation-8.png"
import Hospital9 from "../../assets/hospital-otomation-9.png"
import FikrimVar from "../../assets/fikrim-var.png"
import FikrimVar2 from "../../assets/fikrim-var-2.png"
import FikrimVar3 from "../../assets/fikrim-var-3.png"
import FikrimVar4 from "../../assets/fikrim-var-4.png"
import FikrimVar5 from "../../assets/fikrim-var-5.png"
import FikrimVar6 from "../../assets/fikrim-var-6.png"
import FikrimVar7 from "../../assets/fikrim-var-7.png"
import FikrimVar8 from "../../assets/fikrim-var-8.png"
import FikrimVar9 from "../../assets/fikrim-var-9.png"
import FikrimVar10 from "../../assets/fikrim-var-10.png"
import TMEDETECT from "../../assets/TME-DETECT.png"
import TEKNOFESTUYZ from "../../assets/teknofest-uyz.jpg"
import Datatable from "../../assets/datatable.png"
import FruitNinja from "../../assets/fruit-ninja.png"
import Library from "../../assets/library-otomation.png"
import Library2 from "../../assets/library-otomation-2.png"
import Library3 from "../../assets/library-otomation-3.png"
import Library4 from "../../assets/library-otomation-4.png"
import Library5 from "../../assets/library-otomation-5.png"
import aimouse from "../../assets/aivirtualmouse.png"
import oys from "../../assets/oys1.png"
import oys2 from "../../assets/oys2.png"
// import oys3 from "../../assets/oys5.png"
import oys4 from "../../assets/oys4.png"
import oys5 from "../../assets/oys6.png"
import oys6 from "../../assets/oys7.png"
import oys7 from "../../assets/OYS8.png"
import oys8 from "../../assets/oys9.png"
import oys9 from "../../assets/oys10.png"
import oys10 from "../../assets/oys11.png"
import isyeri_oe from "../../assets/isyeri_oe.png"
import siy from "../../assets/siy.png"
import siy2 from "../../assets/siy2.png"
import siy3 from "../../assets/siy3.png"
import kismi1 from "../../assets/kismi1.png"
import kismi2 from "../../assets/kısmi2.png"
import kismi3 from "../../assets/kısmi3.png"
import kismi4 from "../../assets/kismi4.png"
import kismi5 from "../../assets/kısmi5.png"
import kismi6 from "../../assets/kısmi6.png"
import kismi7 from "../../assets/kısmi7.png"





const Data =[
    {
        id:1,
        img: [kismi1, kismi2, kismi3, kismi4, kismi5, kismi6, kismi7],
        title: "NEÜ Kısmi",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "NEÜ Kısmi Zamanlı Öğrenci ve Yemek Bursu Başvuru Sistemi: ",
            desc: "Ünversite bünyesnde kısmi zamanlı olarak çalışmak isteyen öğrenclerin ve yemek bursu başvurusu yapmak isteyenlern başvuru süreçlerin dijtal ortamda gerçekleştirebilmeler için geliştirilmiş bir platformdur. Proje şu anda geliştirilme aşamasındadır ve yakın zamanda kullanıma sunulacaktır.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "Angular.js - .NET - MSSQL",
        },
        {
            icon: "fa-brands fa-github",
            title: "Video Link: ",
            link: "https://drive.google.com/file/d/1OtI95cp3x5dL5bfwRUHVLVmvKDzjgxNI/view?usp=sharing",
        }
    ]
    },
    {
        id:1,
        img: [isyeri_oe],
        title: "NEÜ OE İşyeri Bilgi Bankası Sayfası",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "NEÜ Ortak Eğitim İşyeri Bilgi Bankası Sayfası: ",
            desc: "Necmettin Erbakan Üniversitesi Mühendislik Fakültesi'nin ortak eğitim programı kapsamında anlaşmalı firmaların yer aldığı ve öğrencilere bilgi sağladığı bir web sayfasıdır. Şehre ve bölüme göre filtreleme ve arama seçenekleri sunar.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "HTML - CSS - Vanilla JS",
        },
        {
            icon: "fa-brands fa-github",
            title: "Web Sitesi Linki: ",
            link: "https://erbakan.edu.tr/ortakegitim/sayfa/4002123/isyeri-bilgi-bankasi",
        }
    ]
    },
    {
        id:1,
        img: [oys, oys2, oys4, oys5, oys6, oys7, oys8, oys9, oys10],
        title: "Öğrenci Yoklama Sistemi",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "Öğrenci Yoklama Sistemi: ",
            desc: "Necmettin Erbakan Üniversitesi Bilgisayar Mühendisliği 6.dönem seçmeli dersi olan \"Gömülü Sistemler\" dersi final projesi için ESP32 kullanılarak geliştirilmiş öğrenci yoklama sistemidir.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "Arduino - ESP32 - React.js - Node.js - MSSQL",
        },
        {
            icon: "fa-brands fa-github",
            title: "Source Code: ",
            link: "https://github.com/SemaEkmekci/Ogrenci_Yoklama_Sistemi",
        }
    ]
    },
    {
        id:1,
        img: [siy3, siy, siy2],
        title: "Teknofest 2024-Sürü İHA Yarışması",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "Teknofest 2024 Sürü İHA Yarışması: ",
            desc: "NEÜ KAPSÜL AIGENZ Takımı olarak geliştirdiğimiz İHA'ların sürü halinde senkronize bir şekilde belirli görevleri yerine getirmesini sağladık.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "Gazebo - Ardupilot - Python - Linux",
        },
        {
            icon: "fa-brands fa-github",
            title: "Video Link: ",
            link: "https://www.youtube.com/watch?v=Zm_bB5C99lA",
        }
    ]
    },
    {
        id:1,
        img: [aimouse],
        title: "OpenCv ile Sanal Mouse",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "OpenCv ile Sanal Mouse (AiVirtualMouse): ",
            desc: "Necmettin Erbakan Üniversitesi Bilgisayar Mühendisliği 6.dönem seçmeli dersi olan \"Görüntü İşleme\" dersi final projesi için geliştirilmiş kamerada el görüntüsü ile mouse kontrolu uygulamasıdır.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "OpenCv - Django",
        },
        {
            icon: "fa-brands fa-github",
            title: "Source Code: ",
            link: "https://github.com/SemaEkmekci/aiVirtualMouse_Django_Project",
        }
    ]
    },
    {

        id:2,
        img: [TMEDETECT],
        title: "Tübitak-1002 TME DETECT",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "TME DETECT: ",
            desc: "\"Panoramik radyografiler ile temporomandibular eklem bölgesindeki dejeneratif            değişikliklerin tespit edilmesi\" için YoloV5 ile eğitilmiş yapay zeka modelinin kulllanıcılar tarafından kullanılması için geliştirilmiştir.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "HTML-CSS-JS-DJANGO-MYSQL",
        },
        {
            icon: "fa-brands fa-github",
            title: "Video Link: ",
            link: "https://drive.google.com/file/d/1MdFOGAf_j6v-B1R-ubwp7y4eRy6GfRew/view?usp=sharing",
        }
    ]
    },
    {
        id:3,
        img: [Langman,Langman2,Langman3,Langman4,Langman5,Langman6],
        title: "H-Langman",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "H-Langman: ",
            desc: "Necmettin Erbakan Üniversitesi Bilgisayar Mühendisliği 5.dönem seçmeli dersi olan \"Programlama Dilleri Kavramları\" dersi final projesi için geliştirilmiş bir masaüstü uygulama oyunudur.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "Qt - C++",
        },
        {
            icon: "fa-brands fa-github",
            title: "Source Code: ",
            link: "https://github.com/SemaEkmekci/Qt-Creator--H-Langman",
        }
    ]
    },
    {
        id:4,
        img: [Hospital,Hospital2,Hospital3,Hospital4,Hospital5,Hospital6,Hospital7,Hospital8,Hospital9],
        title: "Hastane Randevu Sistemi",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "Hastane Randevu Sistemi: ",
            desc: "Necmettin Erbakan Üniversitesi Bilgisayar Mühendisliği 5.dönem seçmeli dersi olan \"Web Programlama\" dersi final projesi için geliştirilmiştir.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "React.js - PHP",
        },
        {
            icon: "fa-brands fa-github",
            title: "Github: ",
            link: "https://github.com/SemaEkmekci/Hastane-Otomasyonu",
        }
    ]
    },
    {
        id:5,
        img: [FikrimVar,FikrimVar2,FikrimVar3,FikrimVar4,FikrimVar5,FikrimVar6,FikrimVar7,FikrimVar8,FikrimVar9,FikrimVar10],
        title: "Fikrim Var",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "Fikrim Var: ",
            desc: "Kapsül Teknoloji Platformu için geliştirdiğim \"Fikrim Var\" projesi, platform kullanıcılarına proje fikirlerini ilgili birim sorumlusuna ileterek tanıtma fırsatı sunuyor. Bu sayede kullanıcılar, birim sorumlularından gelen geri bildirimleri değerlendirebilirler Ayrıca, projelerini daha ayrıntılı şekilde tartışmak isteyen kullanıcılar, istedikleri takdirde birim sorumlularıyla randevu oluşturabilirler.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "React.js - Node.js",
        },
        {
            icon: "fa-brands fa-github",
            title: "Github: ",
            link: "https://github.com/SemaEkmekci/fikrim-var-project?tab=readme-ov-file",
        }
    ]
    },
    {
        id:6,
        img: [TEKNOFESTUYZ],
        title: "Teknofest - Ulaşımda Yapay Zeka",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "Ulaşımda Yapay Zeka: ",
            desc: "\"Teknofest ulaşımda yapay zeka\" yarışma kategorisinde \"Neü Kapsül AIgenZ\" takımı olarak yaptığımız Yolov5 algoritması ile nesne tespiti (araba, insan, tır, motor vs.) modeli",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "Python - YOLOV5",
        },
        
    ]
    },
    {
        id:7,
        img: [FruitNinja],
        title: "Fruit-Ninja",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "Fruit-Ninja: ",
            desc: "\"Necmettin Erbakan Üniversitesi\" 2.sınıf bahar dönemi Görsel Programlama dersinde Qt-Creator ile geliştirilmiştir.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "Qt - C++",
        },
        {
            icon: "fa-brands fa-github",
            title: "Github: ",
            link: "https://github.com/SemaEkmekci/GorselProgramlamaQtCreator--Fruit-Ninja",
        }
    ]
    },
    {
        id:8,
        img: [Library,Library2,Library3,Library4,Library5],
        title: "Kütüphane Otomasyonu",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "Kütüphane Otomasyonu: ",
            desc: "\"Necmettin Erbakan Üniversitesi\" 2.sınıf bahar dönemi Görsel Programlama dersinde Qt-Creator ile geliştirilmiştir.",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "Qt - C++",
        },
        {
            icon: "fa-brands fa-github",
            title: "Github: ",
            link: "https://github.com/SemaEkmekci/GorselProgramlamaQtCreator--Kutuphane-Otomasyonu",
        }
    ]
    },
    {
        id:9,
        img: [Datatable, Datatable],
        title: "Datatable",
        details: [{
            icon: "fa-regular fa-file-code",
            title: "Datatable: ",
            desc: "Kullanıcı bilgilerinin göründüğü, ekleme, silme, güncelleme ve arama işlemlerinin yapılabildiği veri tablosu",
        },
        {
            icon: "fa-solid fa-code",
            title: "Language: ",
            desc: "HTML-CSS- Vanilla-JS",
        },
        {
            icon: "fa-brands fa-github",
            title: "Github: ",
            link: "https://github.com/SemaEkmekci/Web_Gelistirme-Web-Development-/tree/main/Js_Table",
        }
    ]
    },
    
    
]
export default Data;